import { render, staticRenderFns } from "./potential.vue?vue&type=template&id=f2dfba62&scoped=true"
import script from "./potential.vue?vue&type=script&lang=js"
export * from "./potential.vue?vue&type=script&lang=js"
import style0 from "./potential.vue?vue&type=style&index=0&id=f2dfba62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dfba62",
  null
  
)

export default component.exports